export const senhaInitialState = {
  dadosDefSenha: [],
  senhaDefinida: [],
};
